import { useEffect } from "react";
import { Link } from "react-router-dom";

import { Header } from "../../components/header";
import { analyticsService } from "../../services/firebase-service";

export const ParticiparComunidadeEmBreve = () => {
  useEffect(() => {
    analyticsService.event("page-participar-comunidade-em-breve");
  }, []);

  return (
    <main className="container">
      <Header />
      <div className="header">
        <h2 className="h5 my-4">🎉 Você está na lista de espera!</h2>
        <div className="box">
          <h3 className="h5 my-4">Em breve, novas vagas para a Comunidade de Empreendedores serão abertas.</h3>
          <p>
            <strong>Fique tranquilo(a)!</strong>
          </p>
          <p>Assim que liberarmos o acesso, você será comunicado com prioridade por e-mail e WhatsApp.</p>
          <p>
            <Link to="/">Ir para página inicial</Link>
          </p>
        </div>
      </div>
    </main>
  );
};
